var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('left-bar'),_c('div',{staticClass:"content"},[_c('top-bar',{attrs:{"is-admin":true}}),_c('router-view',{key:_vm.key,staticClass:"page"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }